import { UsersActionTypes } from "./users-types";
import { GetAllUsersNew } from "../../services/api/user-api";

export const fetchUsersStart = () => ({
  type: UsersActionTypes.FETCH_USERS_START,
});

export const fetchUsersFailure = () => ({
  type: UsersActionTypes.FETCH_USERS_FAILURE,
});

export const fetchUsersSuccess = (payload) => ({
  type: UsersActionTypes.FETCH_USERS_SUCCESS,
  payload: payload,
});

export const fetchAllUsersStart = () => ({
  type: UsersActionTypes.FETCH_ALL_USERS_START,
});

export const fetchAllUsersFailure = () => ({
  type: UsersActionTypes.FETCH_ALL_USERS_FAILURE,
});

export const fetchAllUsersSuccess = (allUsers) => ({
  type: UsersActionTypes.FETCH_ALL_USERS_SUCCESS,
  payload: allUsers,
});

export const setUsersOnPage = (usersOnPage) => ({
  type: UsersActionTypes.SET_USERS_ON_PAGE,
  payload: usersOnPage,
});

export const setSearchQueryUsers = (searchQuery) => ({
  type: UsersActionTypes.SET_SEARCH_QUERY_USERS,
  payload: searchQuery,
});

export const fetchAllUsers = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchAllUsersStart());

      const allUsers = await GetAllUsersNew({
        pageSize: 1000000,
        pageNumber: 1,
        sortDesc: false,
        sortBy: "name",
        filters: [],
      });

      let users = [];

      allUsers.users.forEach(async (user) => {
        users.push({
          user: user,
        });
      });

      dispatch(fetchAllUsersSuccess(users));

      return users;
    } catch (error) {
      dispatch(fetchAllUsersFailure());
      console.log(error);
    }
  };
};

export const fetchUsers = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchUsersStart());

      const allUsers = await GetAllUsersNew(searchQuery);

      let users = [];

      allUsers.Users.forEach((user) => {
        users.push({
          user: user,
        });
      });

      let payload = [users, allUsers.Count];

      dispatch(fetchUsersSuccess(payload));
      dispatch(setSearchQueryUsers(searchQuery));

      return users;
    } catch (error) {
      dispatch(fetchUsersFailure());
      console.log(error);
    }
  };
};

export const addSelectedUser = (userId) => ({
  type: UsersActionTypes.ADD_SELECTED_USER,
  payload: userId,
});

export const deleteSelectedUser = (userId) => ({
  type: UsersActionTypes.DELETE_SELECTED_USER,
  payload: userId,
});

export const setSelectedUser = (userIdList) => ({
  type: UsersActionTypes.SET_SELECTED_USER,
  payload: userIdList,
});

export const setAdminTab = (tab) => ({
  type: UsersActionTypes.SET_ADMIN_TAB,
  payload: tab,
});
